var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2505 10C19.2505 14.9706 15.2211 19 10.2505 19C5.27993 19 1.25049 14.9706 1.25049 10C1.25049 5.02944 5.27993 1 10.2505 1C15.2211 1 19.2505 5.02944 19.2505 10ZM20.2505 10C20.2505 15.5228 15.7733 20 10.2505 20C4.72764 20 0.250488 15.5228 0.250488 10C0.250488 4.47715 4.72764 0 10.2505 0C15.7733 0 20.2505 4.47715 20.2505 10ZM10.563 9.6875H13.938C14.1106 9.6875 14.2505 9.82741 14.2505 10C14.2505 10.1726 14.1106 10.3125 13.938 10.3125H10.563V13.6875C10.563 13.8601 10.4231 14 10.2505 14C10.0779 14 9.93799 13.8601 9.93799 13.6875V10.3125H6.56299C6.39039 10.3125 6.25049 10.1726 6.25049 10C6.25049 9.82741 6.39039 9.6875 6.56299 9.6875H9.93799V6.3125C9.93799 6.13991 10.0779 6 10.2505 6C10.4231 6 10.563 6.13991 10.563 6.3125V9.6875Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedback);
export default __webpack_public_path__ + "static/media/user-feedback.9216ef8a5a61f3467d13932a81899505.svg";
export { ForwardRef as ReactComponent };